import React, { FormEvent, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Styled from '../styles/AdminFVContainer.styled';
import StyledPackage from '../styles/FVPackage.styled';
import { bucketS3, caminhoAnexosFerramentaVideo, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';
import { IoReturnUpBackOutline } from 'react-icons/io5';
import { Divider } from 'antd';
import MenuTypePackages from '../components/MenuTypePackages';
import HelpDescription from '../components/HelpDescription';
import FormFVPackage from '../components/FormFVPackage';
import { IFVPackage } from '../interfaces/FVPackage.interface';
import { ToastError, ToastSuccess } from 'components/Toaster';
import Colors from 'enums/Colors';
import FVActionButtons from '../components/FVActionsButton';
import { useFetchFVContainer } from '../hooks/FVContainer/useFetchFVContainer';
import { IFVRoleAction } from '../interfaces/FVRole.interface';
import FormFVRole from '../components/FormFVRole';
import RolesFerramentaVideo from '../components/RolesFerramentaVideo';
import { useFVRoles } from '../hooks/FVRoles/useFVRoles';
import { useFVPackage } from '../hooks/FVPackage/useFVPackage';

const AdminFVContainer = () => {
    const history = useHistory();
    const { idContainer } = useParams<{ idContainer: string }>();
    const [formVisible, setFormVisible] = useState<boolean>(false);
    const [formRoleVisible, setFormRoleVisible] = useState<boolean>(false);
    const [listingRoles, setListingRoles] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

    const [form, setForm] = useState<IFVPackage>({
        id: -1,
        title: '',
        nomenclature: '',
        description: '',
        url: '',
        altUrl: '',
        capaFilepath: '',
        altFilepath: '',
        capaBase64: '',
        ordem: 0,
        notUnit: false,
        packageUnits: [],
    });

    const [formRole, setFormRole] = useState<IFVRoleAction>({
        id: -1,
        categorias: [],
        title: '',
        filePathRegua: '',
        base64: '',
        description: '',
        defaultRole: false,
    });

    const [hoveredIndexCard, setHoveredIndexCard] = useState<number | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm((prev: any) => ({ ...prev, [name]: value }));
    };

    const { useUniqueFerramentaVideo } = useFetchFVContainer();
    const { createPackageMutation, updatePackageMutation, deletePackageMutation } = useFVPackage();
    const { createRoleMutation, updateRoleMutation, deleteRoleMutation } = useFVRoles(Number(idContainer));
    const { data: containerData, isLoading } = useUniqueFerramentaVideo(Number(idContainer));

    const handleResetForm = () => {
        setForm({
            id: -1,
            title: '',
            nomenclature: '',
            description: '',
            url: '',
            altUrl: '',
            capaFilepath: '',
            altFilepath: '',
            capaBase64: '',
            ordem: 0,
            notUnit: false,
            packageUnits: [],
        });
        setFormVisible(false);
    };

    const handleResetFormRole = () => {
        setFormRole({
            id: -1,
            title: '',
            categorias: [],
            filePathRegua: '',
            base64: '',
            description: '',
            defaultRole: false,
        });
        setFormRoleVisible(false);
    };

    const handleSubmit = async (event: FormEvent<Element>) => {
        event.preventDefault();
        setLoadingSubmit(true);

        if (form.id > 0) {
            // Atualizar pacote existente
            updatePackageMutation.mutate(
                { idFerramenta: Number(idContainer), data: form },
                {
                    onSuccess: () => {
                        ToastSuccess('Pacote atualizado com sucesso!');
                        handleResetForm();
                        setLoadingSubmit(false);
                    },
                    onError: error => {
                        ToastError('Erro ao atualizar pacote. Tente novamente mais tarde.');
                        setLoadingSubmit(false);
                    },
                }
            );
        } else {
            // Criar novo pacote
            createPackageMutation.mutate(
                { idFerramenta: Number(idContainer), data: form },
                {
                    onSuccess: () => {
                        ToastSuccess('Pacote criado com sucesso!');
                        handleResetForm();
                        setLoadingSubmit(false);
                    },
                    onError: error => {
                        ToastError('Erro ao criar pacote. Tente novamente mais tarde.');
                        setLoadingSubmit(false);
                    },
                }
            );
        }
    };
    const handleSubmitRole = async (event: FormEvent<Element>) => {
        event.preventDefault();
        setLoadingSubmit(true);

        if (formRole.id > 0) {
            // Atualizar regra existente
            updateRoleMutation.mutate(
                { idRole: formRole.id, dataForm: formRole },
                {
                    onSuccess: () => {
                        ToastSuccess('Regra atualizada com sucesso!');
                        handleResetFormRole();
                        setLoadingSubmit(false);
                    },
                    onError: error => {
                        ToastError('Erro ao atualizar regra. Tente novamente mais tarde.');
                        setLoadingSubmit(false);
                    },
                }
            );
        } else {
            // Criar novo pacote
            createRoleMutation.mutate(formRole, {
                onSuccess: () => {
                    ToastSuccess('Regra criada com sucesso!');
                    handleResetFormRole();
                    setLoadingSubmit(false);
                },
                onError: error => {
                    ToastError('Erro ao criar regra. Tente novamente mais tarde.');
                    setLoadingSubmit(false);
                },
            });
        }
    };

    const deleteRole = (idRole: number) => {
        deleteRoleMutation.mutate(idRole, {
            onSuccess: () => {
                ToastSuccess('Regra excluída com sucesso!');
            },
            onError: error => {
                ToastError('Erro ao excluir regra. Tente novamente mais tarde.');
            },
        });
    };

    if (isLoading || !containerData) {
        return (
            <Styled.ContainerPage.Content>
                <div className="loaderConteudo" />
            </Styled.ContainerPage.Content>
        );
    }

    const getS3BaseUrlGeneral = (): string => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };

    const getS3BaseUrlFerramentaVideo = (): string => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    const handleDelete = (id: number) => {
        deletePackageMutation.mutate(
            { packageId: id },
            {
                onSuccess: () => {
                    ToastSuccess('Pacote excluído com sucesso!');
                },
                onError: () => {
                    ToastError('Erro ao excluir pacote. Tente novamente mais tarde.');
                },
            }
        );
    };

    const handleEditForm = (formData: any) => {
        setForm(formData);
        setFormVisible(true);
        window.scrollTo(0, 0);
    };
    const handleEditFormRole = (formData: any) => {
        const idsCategorias = formData?.categorias?.map((c: any) => c.categoria.id);
        setFormRole({ ...formData, categorias: idsCategorias });
        setFormRoleVisible(true);
        window.scrollTo(0, 0);
    };


    const goToPackageContent = (packageFV: IFVPackage) => {
        if (packageFV) {
            if (packageFV.notUnit) {
                history.push(`/admin/ferramenta-video/${idContainer}/${packageFV.id}/${Array.isArray(packageFV.packageUnits) ? packageFV.packageUnits[0].id : ''}`);
                return;
            }
        }
        history.push(`/admin/ferramenta-video/${idContainer}/${packageFV.id}`);
    };

    return (
        <Styled.ContainerPage.Content>
            <MenuTypePackages hidden={containerData.notAccessibility} />
            <FormFVPackage
                formVisible={formVisible}
                handleSubmit={handleSubmit}
                loading={loadingSubmit}
                setForm={setForm}
                setFormVisible={() => handleResetForm()}
                form={form}
                handleChange={handleChange}
            />

            <FormFVRole
                formVisible={formRoleVisible}
                handleSubmit={handleSubmitRole}
                loading={loadingSubmit}
                setForm={setFormRole}
                setFormVisible={() => handleResetFormRole()}
                form={formRole}
                handleChange={handleChange}
            />

            <Styled.Button style={{ width: 'fit-content', padding: '8px 12px' }} onClick={() => history.push(`/admin/ferramenta-video`)}>
                <IoReturnUpBackOutline size={22} /> Voltar
            </Styled.Button>
            {containerData?.codigoSolucao ? (
                <Styled.ContainerPage.LogoSolucao
                    src={getS3BaseUrlGeneral() + containerData?.codigoSolucao.logo}
                    alt={containerData?.codigoSolucao.nome}
                />
            ) : null}
            <Styled.ContainerPage.Title>{containerData?.title}</Styled.ContainerPage.Title>
            <Styled.ContainerPage.Description dangerouslySetInnerHTML={{ __html: containerData?.description }} />
            <Divider style={{ backgroundColor: '#f0f0f0', margin: '16px 0' }} />
            <Styled.Row style={{ justifyContent: 'space-between' }}>
                <Styled.Row>
                    <Styled.Button
                        style={{ width: 'fit-content', padding: '8px 12px' }}
                        onClick={() => {
                            setFormVisible(true);
                            window.scrollTo(0, 0);
                        }}
                    >
                        Criar um novo pacote
                    </Styled.Button>
                    <HelpDescription msg="O pacote é o mesmo conceito de criar um novo livro, a onde você pode organizar seus conteúdos de forma mais eficiente." />
                </Styled.Row>
                <Styled.Row>
                    <Styled.Button
                        style={{ display: 'flex', width: 'fit-content', padding: '8px 12px', alignSelf: 'end', justifySelf: 'end' }}
                        onClick={() => {
                            setFormRoleVisible(true);
                            window.scrollTo(0, 0);
                        }}
                    >
                        Criar regra de negócio
                    </Styled.Button>
                    <Styled.Button
                        style={{ display: 'flex', width: 'fit-content', padding: '8px 12px', alignSelf: 'end', justifySelf: 'end' }}
                        onClick={() => {
                            setListingRoles(!listingRoles);
                        }}
                    >
                        {listingRoles ? 'Listar os Pacotes' : 'Listar as regras'}
                    </Styled.Button>
                </Styled.Row>
            </Styled.Row>
            {!listingRoles && (
                <StyledPackage.Container>
                    {containerData?.pacotes
                        ?.sort((a, b) => a.ordem - b.ordem)
                        .map((pacote, index) => (
                            <section key={pacote.id} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <StyledPackage.Card.Container
                                    onMouseEnter={() => setHoveredIndexCard(index)}
                                    onMouseLeave={() => setHoveredIndexCard(null)}
                                    onClick={() => goToPackageContent(pacote)}
                                >
                                    <StyledPackage.Card.Content
                                        width="322px"
                                        background={Colors.White}
                                        radius="25px 0px 0px 25px"
                                        className="hoverCardPackage"
                                    >
                                        <h1>{pacote.ordem}</h1>
                                    </StyledPackage.Card.Content>
                                    <StyledPackage.Card.Content
                                        width="282px"
                                        img={getS3BaseUrlFerramentaVideo() + pacote.capaFilepath}
                                        radius="0px 25px 25px 0px"
                                    ></StyledPackage.Card.Content>
                                </StyledPackage.Card.Container>
                                <StyledPackage.Card.Information.Container>
                                    <StyledPackage.RowBettween>
                                        <StyledPackage.Card.Information.Title hovered={hoveredIndexCard === index}>
                                            {pacote.title}
                                        </StyledPackage.Card.Information.Title>
                                        <FVActionButtons
                                            onDelete={() => handleDelete(pacote.id)}
                                            onEdit={() => handleEditForm(pacote)}
                                            msgDelete="Tem certeza que deseja deletar este pacote?"
                                        />
                                    </StyledPackage.RowBettween>
                                    <StyledPackage.Card.Information.Description dangerouslySetInnerHTML={{ __html: pacote.description }} />
                                </StyledPackage.Card.Information.Container>
                            </section>
                        ))}

                    {containerData?.pacotes?.length === 0 && <h2>Nenhum pacote criado ainda.</h2>}
                </StyledPackage.Container>
            )}

            {listingRoles && <RolesFerramentaVideo roles={containerData?.roles} deleteRole={deleteRole} handleEditForm={handleEditFormRole} />}
        </Styled.ContainerPage.Content>
    );
};

export default AdminFVContainer;
